import { NavH, SafeAreaConstantPadding, SafeAreaEnvPadding } from '@styles/base.style'
import styled from '@themes/theme'

export const NavbarWrap = styled.div`
  position: fixed;
  bottom: -1px;
  left: 0;
  width: 100%;
  min-height: ${NavH};
  padding-top: 2px;
  padding-bottom: ${SafeAreaEnvPadding};
  padding-bottom: ${SafeAreaConstantPadding};
  background: ${props => props.theme.color.mainBg};
  border-top: 1px solid rgba(45, 55, 69, .5);
  transition: all .05s ease-in-out;
  opacity: 0;
  &.show {
    opacity: 1;
    transition: all .3s;
  }
  .nav-list {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 2px 9px 6px;
    li {
      position: relative;
      &:nth-of-type(2), &:nth-of-type(4) {
        min-width: 46px;
      }
      .menu-item {
        position: relative;
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-items: center;
        svg {
          width: 21px;
          .fill {
            fill: ${props => props.theme.color.disableTxt};
          }
        }
        .refresh-ico {
          display: none;
          position: absolute;
          top: -5px;
          left: 50%;
          transform: translateX(15%);
          width: 16px;
          height: 16px;
          svg {
            width: inherit;
          }
          &.none{
            opacity: 0;
          }
        }
        .menu-name {
          margin-top: 2px;
          line-height: 12px;
          font-size: ${props => props.theme.font.small};
          font-weight: ${props => props.theme.fontW.medium};
          color: ${props => props.theme.color.disableTxt};
        }
      }
      .menu-input {
        position: absolute;
        left: 0;
        width: 1px;
        height: 1px;
        margin: -1px;
        padding: 0;
        overflow: hidden;
        border: 0;
        clip: rect(0, 0, 0, 0);
      }
      &.active {
        svg {
          .fill {
            fill: ${props => props.theme.color.themeTxt};
          }
        }
        .menu-name {
          color: ${props => props.theme.color.themeTxt};
        }
        .refresh-ico {
          display: block;
        }
      }
    }
    .nav-notice-badge {
      position: absolute;
      top: 4px;
      right: 19px;
      width: 6px;
      height: 6px;
    }
  }

  .value, .num {
    display: none;
  }
  .betslip {
    z-index: 1;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 51px;
    height: 51px;
    margin: 0 -10px;
    border-radius: 50%;
    background: #171A24;
    .menu-input, .menu-item {
      display: none;
    }
    .value, .num {
      display: block;
    }
  }

  .gift-box-alert-bubble {
    z-index: -1;
    position: absolute;
    top: -33px;
    left: -20px;
    width: 70px;
    height: 28px;
    &.alert-none{
      display: none;
    }
  }
`
